import React, { useContext, useEffect, useState } from "react";
import translations from "../../data/langData";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { addItem } from "../../utils/addtocart";
import slugify from "slugify";
import LazyLoad from "react-lazy-load";
import parallax1 from "../../assets/image/vertuparallax.webp";
import ApiLinkContext from "../../context/ApiLinkContext";
const Products = () => {
  const {data} = useContext(ApiLinkContext)
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [modalDesc, setModalDesc] = useState(false);
  const [grid, setGrid] = useState("4");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setGrid(1);
      } else {
        setGrid(4);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const ironFlipData = data.filter((item) => item.name_show.includes("Quantum "));
  return (
    <>
      <div className="parallaxImg"></div>
      <section className="flat-spacing-6">
        <div className="container">
          <div className="flat-title mb_1 gap-14 text-center">
            <span className="title wow fadeInUp h2" data-wow-delay="0s" style={{ color: 'var(--main-color)', letterSpacing: '4px' }}>
              VERTU QUANTUM FLIP
            </span>
          </div>
          <Toaster position="top-right" />
          
          <div className="product-carousel-wrapper mt-5">
            <div className="row g-4 justify-content-center">
            {ironFlipData
             .slice(0,4).map((i, index) => {
                // Determine responsive classes to create an asymmetrical feel or tight grid
                return (
                  <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={index}>
                    <div className="card-product style-4 fl-item w-100">
                      <div className="card-product-wrapper position-relative">
                        <NavLink
                          to={`/collections/${slugify(
                            `${i.name_show}-${i.memory + "GB"}-${i.value}`
                          ).toLowerCase()}`}
                          className="product-img"
                          onClick={() => window.scrollTo({ top: 0 })}
                        >
                          <LazyLoad>
                            <img
                              className="lazyload img-product aboutDesc"
                              data-src={i.icon}
                              src={i.icon}
                              alt="image-product"
                            />
                          </LazyLoad>
                          <LazyLoad>
                            <img
                              className="lazyload img-hover aboutDesc"
                              data-src={i.icon}
                              src={i.icon}
                              alt="image-product"
                            />
                          </LazyLoad>
                        </NavLink>
                        
                        <div className="list-product-btn column-right">
                          <a
                            href="javascript:void(0);"
                            className="box-icon wishlist bg_white round btn-icon-action"
                            style={{ background: 'var(--surface-color)', color: 'var(--main-color)' }}
                            onClick={async () => {
                              const added = await addItem(i);
                              if (added) {
                                toast.success(
                                  `${t.basket}-${i.name_show.split(" (")[0]} ${
                                    i.value
                                  }`,
                                  {
                                    className: "py-3 px-2",
                                    duration: 1000,
                                  }
                                );
                              }
                            }}
                          >
                            <span className="icon icon-bag" />
                            <span className="tooltip">{t.quickadd}</span>
                          </a>
                        </div>
                        
                        <button
                          style={{ border: "none", zIndex: "1", width: "90%", margin: "0 auto", position: "absolute", bottom: "10px", left: "5%" }}
                          onClick={async () => {
                            const added = await addItem(i);
                            if (added) {
                              toast.success(
                                `${t.basket}-${i.name_show.split(" (")[0]} ${
                                  i.value
                                }`,
                                {
                                  className: "py-3 px-2",
                                  duration: 1000,
                                }
                              );
                            }
                          }}
                          data-bs-toggle="modal"
                          className="tf-btn btn-fill justify-content-center animate-hover-btn"
                        >
                          {t.addtocart}
                        </button>
                      </div>
                      
                      <div className="card-product-info text-center mt-3 pb-3">
                        <NavLink
                          to={`/collections/${slugify(
                            `${i.name_show}-${i.memory + "GB"}-${i.value}`
                          ).toLowerCase()}`}
                          className="title link aboutDesc h5"
                          onClick={() => window.scrollTo({ top: 0 })}
                        >
                          {i.name_show.split(" (")[0]} 
                          <br />
                          <span style={{ fontSize: "14px", color: 'var(--text-secondary)' }}>{i.value}</span>
                        </NavLink>
                        <hr style={{ borderColor: 'var(--glass-border)', width: '50%', margin: '15px auto' }} />
                        <span className="price aboutDesc fw-bold" style={{ color: 'var(--text-primary)' }}>{i.price} ₼</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          
          <div className="tf-pagination-wrap view-more-button text-center mt-5">
            <NavLink
              to="/collections"
              onClick={() => window.scrollTo({ top: 0 })}
            >
              <button className="tf-btn-loading tf-loading-default style-2 btn-loadmore" style={{ backgroundColor: 'transparent', border: '1px solid var(--main-color)', color: 'var(--main-color)' }}>
                <span className="text">{t.readmore}</span>
              </button>
            </NavLink>
          </div>
        </div>
      </section>
      <div
        className={`modal fade modalDemo ${modalDesc ? "show" : ""} `}
        id="quick_view"
        style={{
          display: `${modalDesc ? "block" : "none"}`,
          background: `${modalDesc ? "rgb(0 0 0 / 54%)" : ""}`,
          cursor: "default",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="header">
              <span
                className="icon-close icon-close-popup"
                data-bs-dismiss="modal"
                onClick={() => setModalDesc(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
